<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <add-new-char-sidebar :isCharSidebarActive="charSidebar" :selectedCharacter="selectedCharRow" :buttoncaption="caption" :charSidebarHeader="sbarHeaderChar" @saveCharData="charDataSaved" @closeSidebar="charSidebar = false" @showHideCard="charLookCardHideShow(selectedCharRow.id,selectedCharRow.name)"/>

    <vs-table ref="characterTable" class="vs-con-loading__container" v-model="charTable" @selected="charSelected" pagination :max-items="itemsPerPage" search :data="characters" >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
          <!-- ADD NEW -->
          <div :buttoncaption="caption" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="showCharSidebar" >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-success">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
            <span class="mr-2" >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ characters.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : characters.length }} of {{ characters.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="description">Description</vs-th>
        <vs-th sort-key="modifiedOn">Modified On</vs-th>
        <vs-th sort-key="modifiedBy">Modified By</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <img :src="tr.imageUrl || 'https://forty5degreesstorage.blob.core.windows.net/assets/avatar-placeholder.png'" height="100px" @click.stop="charLookCardHideShow(tr.id,tr.name)" v-scroll-to="'#charlook'" >
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.name }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.description }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedOn.replace("T", " ").split('.')[0] }}</p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">{{ tr.modifiedBy.replace("T", " ") }}</p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <div class="pt-8">
      <add-new-char-looks-sidebar :isCharLooksSidebarActive="charLooksSidebar" :selectedCharId="charId" :selectedCharLook="selectedCharLookRow" :buttoncaption="caption" :charLooksSidebarHeader="sbarHeaderCharLook" @saveLookData="looksDataSaved" @closeCharLooksSidebar="charLooksSidebar = false"/>
      <!-- ### Character Looks Table ### -->
      <vx-card id="charlook" :title="characterLookCardName + '\'s Looks'" ref="charLooksCard" v-show="isCharLookCardVisible" >
        <vs-table ref="characterLooksTable" class="vs-con-loading__container" v-model="charLookTable" @selected="charLookSelected" pagination :max-items="itemsPerPage" search :data="characterLooks" v-scroll-to="{el: '#nameLabel', container: '#add-new-char-looks-sidebar', duration: 500}" >
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <div class="flex flex-wrap-reverse items-center">
              <!-- ADD NEW -->
              <div :buttoncaption="caption" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="showCharLooksSidebar">
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
                <span class="ml-2 text-base text-success">Add</span>
              </div>
            </div>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
              <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ characterLooks.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : characterLooks.length }} of {{ characterLooks.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage=10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=20">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=25">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=50">
                  <span>50</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage=100">
                  <span>100</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>

          <template slot="thead">
            <vs-th>Image</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="description">Description</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
          </template>

          <template slot-scope="{data}">
            <tbody>
              <vs-tr :data="look" :key="indextr" v-for="(look, indextr) in data">
                <vs-td>
                  <img :src="look.thumbnailUrl">
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium">{{ look.name }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-category">{{ look.description }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium">{{ look.modifiedOn.replace("T", " ").split('.')[0] }}</p>
                </vs-td>

                <vs-td>
                  <p class="product-name font-medium">{{ look.modifiedBys }}</p>
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import AddNewCharSidebar from "./CharacterForm.vue";
import AddNewCharLooksSidebar from "./CharacterLooksForm.vue";

export default {
  components: {
    AddNewCharSidebar,
    AddNewCharLooksSidebar
  },
  data() {
    return {
      charTable: [],
      charLookTable: [],
      characters: [],
      charId: 0,
      characterLooks: [],
      itemsPerPage: 6,
      isMounted: false,
      charSidebar: false,
      charLooksSidebar: false,
      selectedCharRow: {},
      selectedCharLookRow: {},
      caption: "",
      sbarHeaderChar: "",
      sbarHeaderCharLook: "",
      isCharLookCardVisible: false,
      characterLookCardName: ""
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.characterTable.currentx;
      }
      return 0;
    }
  },
  methods: {
    charSelected(tr) {
      this.charSidebar = true;
      this.selectedCharRow = tr;
      this.charId = tr.id;
      this.caption = "Update";
      this.sbarHeaderChar = "Update Character";
      this.isCharLookCardVisible = false;
    },
    charLookSelected(look) {
      this.charLooksSidebar = true;
      this.selectedCharLookRow = look;
      this.caption = "Update";
      this.sbarHeaderCharLook = "Update Character Look";
    },
    showCharSidebar() {
      this.charSidebar = true;
      this.selectedCharRow = {};
      this.caption = "Add";
      this.sbarHeaderChar = "Add Character";
    },
    showCharLooksSidebar() {
      this.charLooksSidebar = true;
      this.selectedCharLookRow = {};
      this.caption = "Add";
      this.sbarHeaderCharLook = "Add Character Look";
    },
    charDataSaved() {
      this.charSidebar = false;
      this.loadCharData();
    },
    looksDataSaved() {
      this.charLooksSidebar = false;
      this.loadCharLooksData(this.charId);
    },
    loadCharData() {
      const self = this;
      self.showLoadingOnCharTable();

      var onSuccess = function(response) {
        self.characters = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.characterTable.$el);
        self.$refs.characterTable.searchx = "";
      };

      self.$ajaxGet(self, "character/listcharacter", onSuccess, onFinally);
    },
    loadCharLooksData(id) {
      this.loadCharData();
      const self = this;
      self.showLoadingOnCharLooksTable();

      var onSuccess = function(response) {
        response.data.forEach(element => {
          element.thumbnailUrl = element.thumbnailUrl + "?rand=" + new Date().getTime();
        });
        self.characterLooks = response.data;
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.characterLooksTable.$el);
        self.$refs.characterLooksTable.searchx = "";
      };

      self.$ajaxGet(self, "character/listcharacterlooks/" + id, onSuccess, onFinally);
    },
    charLookCardHideShow(id, name) {
      this.characterLookCardName = name;
      this.charId = id;
      this.charSidebar = false;
      this.isCharLookCardVisible = true;
      this.loadCharLooksData(id);
    },
    showLoadingOnCharTable(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$refs.characterTable.$el,
        scale: 1
      });
    },
    showLoadingOnCharLooksTable(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$refs.characterLooksTable.$el,
        scale: 1
      });
    },
  },
  mounted() {
    this.loadCharData();
    this.isMounted = true;

    if(this.$route.path == "/digi/characters")
      this.$store.dispatch("updateTheme", "dark");
  }
};
</script>

<style lang="scss">
#data-list-thumb-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 10px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
          &.img-container {

            span {
              display: flex;
              justify-content: center;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
